import React from 'react'
import Image from '../../../common/Image'

const FALLBACK_IMAGE = '/images/factory-demo.jpg'

const formatCompact = (value) => {
    const num = Number(value ?? 0)
    if (Math.abs(num) >= 1000000) return `${(num / 1000000).toFixed(1)}M`
    if (Math.abs(num) >= 1000) return `${(num / 1000).toFixed(1)}K`
    return num.toLocaleString('en-US')
}

const formatCurrency = (value) => `$${formatCompact(value)}`

const STATUS_STYLES = {
    ACTIVE: { bg: '#eaf7ee', text: '#1a7f37' },
    INACTIVE: { bg: '#f4f4f5', text: '#6a6c71' },
    PENDING: { bg: '#fff5e6', text: '#b26a00' },
    VERIFIED: { bg: '#e8f0fe', text: '#1466ff' }
}

const formatStatusLabel = (status) =>
    (status || '')
        .toString()
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/^\w/, (c) => c.toUpperCase())

const StatusBadge = ({ status }) => {
    if (!status) return null
    const style = STATUS_STYLES[status] || { bg: '#f4f4f5', text: '#6a6c71' }
    return (
        <span
            className='regular-12 weight-500 px-2 py-0.5 rounded-full shrink-0'
            style={{ backgroundColor: style.bg, color: style.text }}
        >
            {formatStatusLabel(status)}
        </span>
    )
}

// Single supplier tile used by the Supplier performance section and its modal.
const SupplierCard = ({ supplier }) => (
    <div className='border border-[#e9e9ea] bg-white flex flex-col'>
        <div className='relative h-[280px] bg-[#f4f4f5] overflow-hidden'>
            <Image
                src={supplier.previewImageUrl || FALLBACK_IMAGE}
                alt={supplier.name}
                className='w-full h-full object-cover'
                loading='lazy'
                onError={(e) => {
                    e.target.onerror = null
                    e.target.src = FALLBACK_IMAGE
                }}
                isStatic={!supplier.previewImageUrl}
            />
            {supplier.threeSixtyViewUrl && (
                <a
                    href={supplier.threeSixtyViewUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='absolute top-3 right-3 inline-flex items-center justify-center bg-white/90 border border-[#266ef1] text-[#266ef1] hover:bg-[#266ef1] hover:text-white transition-colors regular-12 weight-500 h-8 px-3 rounded'
                >
                    360° view
                </a>
            )}
        </div>
        <div className='p-5 flex flex-col gap-3 flex-1'>
            <div className='flex items-start justify-between gap-2'>
                <div className='min-w-0'>
                    <h3 className='regular-14 weight-500 text-[#21242b] truncate'>
                        {supplier.name}
                    </h3>
                    {supplier.location && (
                        <p className='regular-12 text-[#999a9d] truncate mt-0.5'>
                            {supplier.location}
                        </p>
                    )}
                </div>
                <StatusBadge status={supplier.supplierStatus} />
            </div>

            <div>
                <p className='text-[22px] leading-7 font-bold text-[#21242b]'>
                    {formatCurrency(supplier.orderValue)}
                </p>
                <p className='regular-12 text-[#6a6c71] mt-1'>Order value</p>
            </div>
        </div>
    </div>
)

export default SupplierCard
